import styled from 'styled-components'

import { colors } from 'shared/styles/colors'

export const Container = styled.div`
  display: flex;
  height: 100vh;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  background: ${colors.blue};

  padding: 30px 0px 30px 0px;
`

export const ContainerModal = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px 0px;
`

export const ContainerDescription = styled.div`
  width: 430px;
  height: 146px;
`

export const Title = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.blue};
  text-align: center;
`

export const Description = styled.p`
  font-size: 14px;
  color: ${colors.grayDark};
  text-align: center;
  line-height: 22.4px;
`
